module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items) ? _c('div', {
    staticClass: "page7 animated fadeIn"
  }, [_c('img', {
    attrs: {
      "src": "media/page7/trophy.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "src": "media/page7/congrats.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "animated fadeIn",
    domProps: {
      "innerHTML": _vm._s(_vm.items.final)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f36c8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page7.vue
// module id = 138
// module chunks = 0